import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalRoot } from '../../base';
import HeaderlessLayout from './HeaderlessLayout';
/** Our Standard modal. Has a heading, subheading, close button, and footer.  */ const HeaderlessModal = (_param)=>{
    var { isOpen, headerPadding, footerPadding, children, className, contentClassName, innerScrollRef, withScrollableContentWrapper = true, isFullscreen: isFullscreenProp, layoutClassName, ignoreClickOutside, ipadMode = false, onSubmit } = _param, rest = _object_without_properties(_param, [
        "isOpen",
        "headerPadding",
        "footerPadding",
        "children",
        "className",
        "contentClassName",
        "innerScrollRef",
        "withScrollableContentWrapper",
        "isFullscreen",
        "layoutClassName",
        "ignoreClickOutside",
        "ipadMode",
        "onSubmit"
    ]);
    const isMobile = useContext(MobileContext);
    const enableIpad = ipadMode && typeof document !== 'undefined' && navigator.userAgent.includes('Mac') && 'ontouchend' in document;
    const isFullscreen = (isFullscreenProp !== null && isFullscreenProp !== void 0 ? isFullscreenProp : isMobile) || enableIpad;
    return /*#__PURE__*/ React.createElement(MobileContext.Provider, {
        value: isMobile || (enableIpad !== null && enableIpad !== void 0 ? enableIpad : false)
    }, /*#__PURE__*/ React.createElement(ModalRoot, _object_spread({
        ipadMode: ipadMode,
        isOpen: isOpen,
        className: c(className, ignoreClickOutside && 'ignore-react-onclickoutside'),
        hasCloseButton: false,
        isFullscreen: isFullscreen,
        shouldCloseOnOverlayClick: false
    }, rest), /*#__PURE__*/ React.createElement(HeaderlessLayout, {
        className: layoutClassName,
        isFullscreen: isFullscreen,
        withScrollableContentWrapper: withScrollableContentWrapper,
        innerScrollRef: innerScrollRef,
        content: children,
        contentClassName: contentClassName,
        onSubmit: onSubmit
    })));
};
HeaderlessModal.displayName = 'HeaderlessModal';
export default HeaderlessModal;

//# sourceMappingURL=HeaderlessModal.js.map